// Stub for @stripe/stripe-react-native on web — native modules not available
export const useStripe = () => ({
  initPaymentSheet: null,
  presentPaymentSheet: null,
});
export const StripeProvider = ({ children }) => children;
export const initStripe = async () => {};
